export var RecordingMode;
(function (RecordingMode) {
    RecordingMode["Blackbox"] = "blackbox";
    RecordingMode["Blocking"] = "blocking";
    RecordingMode["InMemory"] = "in-memory";
    RecordingMode["LiveStreaming"] = "live-streaming";
    RecordingMode["Streaming"] = "streaming";
})(RecordingMode || (RecordingMode = {}));
